import { Dialog, Box } from '@mui/material';

import Run from '../../types/run';

import Results from './Results';
import styles from './result.module.css';

function ResultsModal({ runs, onClose, hasToShowResults }: { runs: Run[], onClose: any, hasToShowResults: boolean }) {
  return (<div>
    <Dialog
      open={hasToShowResults}
      onClose={onClose}
      className={styles.modal}
      closeAfterTransition
      maxWidth={'xl'}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Box className={styles.modalContent} sx={{backgroundColor: 'background.paper',}}>
        <Results runs={runs} />
      </Box>
    </Dialog>
  </div>);
}

export default ResultsModal;
